import React from 'react';
import { ReactDatePickerProps } from 'react-datepicker';
import { Form } from 'semantic-ui-react';

import { DatePicker } from 'src/components/custom';
import dayjs from 'src/libs/dayjs';

export type Props = {
  onChange?: (...args: any[]) => void;
  placeholder?: string;
  label?: string;
  id?: string;
  value?: string;
  error?: string;
} & Omit<ReactDatePickerProps, 'onChange' | 'value' | 'selected'>;

const DatePickerField: React.FC<Props> = (props) => {
  const {
    placeholder,
    label,
    id,
    error,
    onChange,
    name,
    value,
    showTimeSelect,
    ...rest
  } = props;

  return (
    <Form.Field error={!!error}>
      <label>{label}</label>
      <DatePicker
        id={id}
        showTimeSelect={showTimeSelect}
        dateFormat={showTimeSelect ? 'yyyy/MM/dd HH:mm:ss' : 'yyyy/MM/dd'}
        selected={value ? dayjs(value).toDate() : undefined}
        onChange={(date, event) => {
          onChange?.(
            {
              target: { value: date, name },
            },
            date,
          );
        }}
        placeholderText={placeholder}
        {...rest}
      />
      {error && <div className="ui pointing above prompt label">{error}</div>}
    </Form.Field>
  );
};

export default DatePickerField;
